import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconEdgeLeft20(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={20}
            height={20}
            className={customClassName}
            name="IconEdgeLeft20"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M13.4 16a1 1 0 1 0 0 2 1 1 0 0 0 0-2m-4.5 1a1 1 0 1 1 2 0 1 1 0 0 1-2 0m-2.5-1a1 1 0 1 0 0 2 1 1 0 0 0 0-2M2 14a.75.75 0 0 0 1.5 0V6A.75.75 0 1 0 2 6zM5.4 3a1 1 0 1 1 2 0 1 1 0 0 1-2 0m12.5 3.5a1 1 0 1 0-2 0 1 1 0 0 0 2 0M8.9 3a1 1 0 1 1 2 0 1 1 0 0 1-2 0m9 7a1 1 0 1 0-2 0 1 1 0 0 0 2 0m-5.5-7a1 1 0 1 1 2 0 1 1 0 0 1-2 0m5.5 10.5a1 1 0 1 0-2 0 1 1 0 0 0 2 0"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconEdgeLeft20);
